import Account from 'components/Controller/Account'
import { Navigate } from 'react-router-dom'
import CreateGroup from './CreateGroup'
import DetailGroup from './DetailGroup'
import Group from './Group'
import UpdateGroup from './UpdateGroup'
const Groups = [
	{
		path: 'account',
		element: <Navigate to='account/groups' />,
	},
	{
		path: 'account/groups',
		element: (
			<Account>
				<Group />
			</Account>
		),
	},
	{
		path: 'account/groups/create',
		element: (
			<Account>
				<CreateGroup />
			</Account>
		),
	},
	{
		path: 'account/groups/update/:id',
		element: (
			<Account>
				<UpdateGroup />
			</Account>
		),
	},
	{
		path: 'account/groups/:id',
		element: (
			<Account>
				<DetailGroup />
			</Account>
		),
	},
]
export default Groups
